import { rates } from './rates';

export const prices = {
  namespaced: true,
  modules: {
    rates
  }
};
